import { LOADING, STATUS_CODE } from "../../constants/constant";
import {
  GET_BRANDS_REQUESTED,
  GET_BRANDS_FAILED,
  GET_BRANDS_SUCCESS,
} from "../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: true,
};

export default function getBrandsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_BRANDS_REQUESTED:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      reqstState.statusCode = STATUS_CODE;
      return reqstState;

    case GET_BRANDS_SUCCESS:
      let userRes = Object.assign({}, state);
      console.log("came to the get brand by profile id success", action);
      userRes.status = action.data.data.status_message;
      userRes.statusCode = action.data.data.status_code;
      userRes.isLoading = false;
      // userRes.statusCode = action.data.data.statusCode;

      userRes.brandList = action.data.data;
      return userRes;

    case GET_BRANDS_FAILED:
      console.log("came to the get brand by profile id failed", action);
      return Object.assign({}, state, action.error);

    default:
      return state;
  }
}
